import { RawEventsConfigurationGridWebComponent } from './component/RawEventsConfigurationGridWebComponent';
import { WEB_COMPONENT_RAW_EVENTS_CONFIGURATION_GRID } from '../webcomponents.constants';

export { RawEventsConfigurationGridWebComponent };

window.customElements.define(WEB_COMPONENT_RAW_EVENTS_CONFIGURATION_GRID, RawEventsConfigurationGridWebComponent);
